import zipCodeActionTypes from '../actionTypes'

const initialState = {
  datatable: {
    data: [],
    total: 1
  }
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case zipCodeActionTypes.GET_ZIPCODE_DATATABLE_DATA:
      return {
        ...state,
        datatable: {
          data: payload.data,
          total: payload.totalPages,
          params: payload.params
        }
      }
    default:
      return state
  }
}
